import { Component, OnInit } from '@angular/core';
import { Stream } from 'src/models/stream';
import { Genre } from 'src/models/genre';
import { StreamService } from 'src/app/services/stream.service';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss']
})
export class OverviewComponent implements OnInit {

  public topStations = new Array<Stream>();
  public topStationsInternational = new Array<Stream>();
  public topCategories = new Array<Genre>();

  constructor(
    private streamService: StreamService) { }

  ngOnInit() {
    this.streamService.getTopStations(0, 30).subscribe((value: Stream[]) => {
      this.topStations = value;
    });

    this.streamService.getTopStationsInternational().subscribe((value: Stream[]) => {
      this.topStationsInternational = value;
    });

    this.streamService.getTopCategories().subscribe((value: Genre[]) => {
        this.topCategories = value;
    });
  }

}
